var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "div",
        {
          ref: "scroller",
          staticClass: "scroll-y",
          style: _vm.coStyle,
          attrs: { id: "scroll-target" }
        },
        [
          _c(
            "v-layout",
            {
              directives: [
                {
                  name: "scroll",
                  rawName: "v-scroll:#scroll-target",
                  value: _vm.handleScroll,
                  expression: "handleScroll",
                  arg: "#scroll-target"
                }
              ],
              staticStyle: { overflow: "hidden" },
              attrs: { column: "" }
            },
            [
              _vm._l(_vm.coActions, function(action, index) {
                return action
                  ? [
                      _vm.visible(action, index)
                        ? _c("message-seperator", {
                            key: index + "-" + action.createdAt,
                            staticClass: "seperator",
                            attrs: {
                              "is-close": action.isClose,
                              label: _vm.$t(
                                _vm.lblSetting.ticketCloseTicketSeperator,
                                action.owner
                              ),
                              date: _vm.getDate(action.createdAt)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isUploading(action)
                        ? _c("message-file-uploading", {
                            key: action.loader_id,
                            attrs: { source: action, "is-owner": _vm.isOwner }
                          })
                        : _vm.isMessage(action)
                        ? _c("message-item", {
                            key: "message-" + index,
                            attrs: {
                              source: action,
                              id: "message-item-" + action.id,
                              index: index
                            },
                            on: {
                              resend: _vm.handleResend,
                              "open-modal": _vm.handleConfirmModal
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isStatement(action)
                        ? _c("message-request-quote", {
                            attrs: { source: action, "is-owner": _vm.isOwner }
                          })
                        : _vm._e()
                    ]
                  : _vm._e()
              })
            ],
            2
          )
        ],
        1
      )
    : _c("chat-message-loader")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bca56b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bca56b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-message/template.html
// module id = null
// module chunks = 